module.exports = __webpack_public_path__ + "img/messekarte_en.0c2ec06a.jpg";